import AdminLobby from './admin-lobby';

export default AdminLobby;
